import { isObject } from 'src/utils/typeguards/isObject';
import type { FetchierConfig } from './types';
import { fetchWithTimeout } from './utils/fetchWithTimeout';
import { generateQueryString } from './utils/generateQueryString';

export async function fetchier(givenUrl: RequestInfo, givenOpts?: FetchierConfig) {
    const opts = givenOpts ?? ({} as FetchierConfig);
    const url = `${givenUrl}${generateQueryString(opts.query)}`;

    if (isObject(opts.body) && !(typeof window !== 'undefined' && opts.body instanceof global.window.FormData)) {
        opts.body = JSON.stringify(opts.body);
    }

    return opts.timeout ? fetchWithTimeout(url, opts, opts.timeout) : fetch(url, opts as RequestInit);
}
